import React, { useEffect, useState ,useRef } from "react";
import { useParams } from "react-router-dom";
import { getProductImage, getProducts } from "../axios";
import PlaybackRate from "./common/PlaybackSpeed";
import ReactPlayer from "react-player";
import CustomVideoPlayer from './common/custom-video-player/CustomVideoPlayer';

const VideoViewDemo = () => {
  var params = useParams();
  const [src, setSrc] = useState();
  const [mediaImage, setMediaImage] = useState("");
  const playerRef = useRef(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const handlePlaybackSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
  };

  let ext = src?.split(".").pop();
  
  const handleSeek = (seconds) => {
    const currentTime = playerRef?.current?.getCurrentTime();
    if (currentTime !== undefined) {
      playerRef?.current?.seekTo(currentTime + seconds, "seconds");
    }
  };

  useEffect(() => {
    try {
      getProducts().then(({ data }) => {
        const filterProduct = data.filter((p) => p.id == params.id);

        setSrc(filterProduct[0].filedemo);
        getProductImage(filterProduct[0].id).then((res) => {
          res.data.lenght && setMediaImage(res.data[0].img);
        });
      });
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div
          className="col-lg-12 col-md-12 flex-column"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {src ? (
            <>
              {ext === "mp4" ? (
                <>
                {/* <CustomVideoPlayer src={src}/> */}
                  <ReactPlayer
                    className="w-100 h-100"
                    ref={playerRef}
                    url={src}
                    controls
                    playing
                    playbackRate={playbackSpeed}
                    config={{
                      file: {
                        attributes: {
                          controlsList: "nodownload",
                        },
                      },
                    }}
                  />
                  <PlaybackRate
                    onPlaybackSpeedChange={handlePlaybackSpeedChange}
                    onSeek={handleSeek}
                  />

                  {mediaImage && (
                    <img
                      src={mediaImage}
                      alt="Media_Image"
                      className="col-11 col-sm-8 mt-3"
                      style={{ objectFit: "contain" }}
                    />
                  )}
                </>
              ) : (
                
                <>
                  {mediaImage && (
                    <img
                      src={mediaImage}
                      alt="Media_Image"
                      className="col-11 col-sm-8 mt-3"
                      style={{ objectFit: "contain" }}
                    />
                  )}

                  <ReactPlayer
                    className="w-100"
                    ref={playerRef}
                    url={src}
                    controls
                    playing
                    playbackRate={playbackSpeed}
                    style={{ maxHeight: 100 }}
                    config={{
                      file: {
                        attributes: {
                          controlsList: "nodownload",
                        },
                      },
                    }}
                  />
                  <PlaybackRate
                    onPlaybackSpeedChange={handlePlaybackSpeedChange}
                    onSeek={handleSeek}
                  />
                </>
                
              )}
            </>
          ) : (
            <span>PLEASE WAIT ...</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoViewDemo;
